import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40887e89"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "selectCard" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "history" }, "操作历史", -1))

import {ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'selectCard',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()

  const iccid = ref('');
  
  const onSubmit = (values: any) => {
    console.log('submit', values);
  };

  const goCardData = () => {
    router.push({name: 'cardData', params: {
      iccid: route.params.iccid
    }})
  }

  const onClickLeft = () => {
    router.go(-1)
  }

return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: (_unref(route).meta.title as string),
      "left-arrow": "",
      onClickLeft: onClickLeft
    }, null, 8, ["title"]),
    _createVNode(_component_van_form, { onSubmit: onSubmit }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_van_field, {
                modelValue: iccid.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((iccid).value = $event)),
                type: "number",
                placeholder: "请输入卡号",
                rules: [{ required: true, message: '请输入ICCID' }]
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", { onClick: onClickLeft }, "取消")
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_3,
    _createElementVNode("p", {
      class: "historyCard",
      onClick: goCardData
    }, [
      _createVNode(_component_van_icon, {
        name: "clock-o",
        class: "icon"
      }),
      _createTextVNode(_toDisplayString(_unref(route).params.iccid), 1)
    ])
  ]))
}
}

})